import * as React from 'react';
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "@reduxjs/toolkit";
import { MultiSelect } from 'primereact/multiselect';
import { Skeleton } from 'primereact/skeleton';

import * as UtilsActions from '../../store/ducks/utils/actions';
import { ApplicationState } from "../../store";

function ListaGrupo({
    multiple = true,
    utils,
    getAllGrupoList,
    grupos,
    onChangeGrupos,
    error
}: any) {

    const [gruposList, setGruposList] = React.useState<any>([]);
    const [gruposSelecionados, setGruposSelecionados] = React.useState<any>([]);
    const [selectAll, setSelectAll] = React.useState(false);
    const [lazyItems, setLazyItems] = React.useState<any>([]);
    const [lazyLoading, setLazyLoading] = React.useState(false);

    const loadLazyTimeout = React.useRef<null | ReturnType<typeof setTimeout>>(null);

    React.useEffect(() => {
        getAllGrupoList()
    }, []);

    React.useEffect(() => {
        setGruposList(utils.data.grupos);
        if (utils.data.grupos && utils.data.grupos.length > 0) {
            if(multiple){
                setSelectAll(grupos.length == utils.data.grupos.length);
            }
        }

    }, [utils.data.grupos]);

    React.useEffect(() => {
        if (grupos) {
            setGruposSelecionados(multiple ? grupos.map((item: any) => item.idGrupo) 
            : grupos.idGrupo ? [grupos.idGrupo] : []);
        }
    }, [grupos]);

    const onLazyLoad = (event: any) => {
        setLazyLoading(true);

        if (loadLazyTimeout.current) {
            clearTimeout(loadLazyTimeout.current);
        }

        loadLazyTimeout.current = setTimeout(() => {
            const { first, last } = event;
            const _lazyItems = [...lazyItems];

            for (let i = first; i < last; i++) {
                _lazyItems[i] = { label: `Item #${i}`, value: i };
            }

            setLazyItems(_lazyItems);
            setLazyLoading(false);
        }, 300);
    }

    return (
        <MultiSelect
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center'
            }}
            {...(!multiple && { selectionLimit: 1 })}
            showSelectAll={multiple}
            value={gruposSelecionados}
            options={gruposList}
            display="chip"
            onChange={(e) => {
                if (e.value) {
                    setGruposSelecionados(e.value);
                    setSelectAll(e.value.length === gruposList.length);
                    onChangeGrupos(gruposList.filter((clust: any) => e.value.includes(clust.idGrupo)));
                } else {
                    setGruposSelecionados([])
                    setSelectAll(false);
                    onChangeGrupos([])
                }
            }}
            selectAll={selectAll}
            optionLabel="nmGrupo"
            optionValue='idGrupo'
            placeholder={
                multiple ? "Selecione os Grupos" : "Selecione um Grupo"
            }
            filter
            showClear={true}
            className={error ? "p-multiselect-error" : ''}
            maxSelectedLabels={3}
            selectedItemsLabel={`${gruposSelecionados ? gruposSelecionados.length : 0} grupos selecionados`}
            emptyFilterMessage='Não encontrado'
            filterPlaceholder={
                multiple ? "Busque por grupos" : "Busque por um grupo"
            }
            resetFilterOnHide={true}
            virtualScrollerOptions={{
                lazy: true, onLazyLoad: onLazyLoad, itemSize: 43, showLoader: true, loading: lazyLoading, delay: 1, loadingTemplate: (options) => {
                    return (
                        <div className="flex align-items-center p-2" style={{ height: '43px' }}>
                            <Skeleton width={options.even ? '70%' : '60%'} height="1.5rem" />
                        </div>
                    )
                }
            }}
        />
    );
}

const mapStateToProps = (state: ApplicationState) => ({
    utils: state.utils
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({ ...UtilsActions }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ListaGrupo);